import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #e9ebee;
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

export const TableName = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #3b364e;
`;

export const ContentWrapper = styled.div`
  margin: 0 6rem;
  width: 100%;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  margin-top: 3rem;
  justify-content: space-between;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/Dashboard/styles.js